import React from 'react';
import { AlertTriangleIcon, ClockIcon, FileSignatureIcon, InboxIcon, MapIcon, ShieldCheckIcon, UsersIcon } from 'lucide-react';
import { dispatchFeatures } from '../data/content';
const icons = {
  map: MapIcon,
  clock: ClockIcon,
  alert: AlertTriangleIcon,
  users: UsersIcon,
  shield: ShieldCheckIcon,
  inbox: InboxIcon,
  signature: FileSignatureIcon
};
export function DispatchBrain() {
  return <section id="dispatch" aria-labelledby="dispatch-title" className="border-b border-white/5 bg-ink-900" data-id="element-53" data-mp="qec25ynkv8hp">
      <div className="mx-auto max-w-content px-5 py-20 sm:px-8 sm:py-24" data-id="element-54" data-mp="mbyv96x3h4jc">
        <p className="text-xs font-semibold uppercase tracking-[0.18em] text-brand" data-id="element-55" data-mp="104yb5a0sh0rf">
          The dispatch brain
        </p>
        <h2 id="dispatch-title" className="mt-5 max-w-2xl font-display text-3xl font-bold leading-tight tracking-tight text-white sm:text-4xl" data-id="element-56" data-mp="v8g7yel3xah7">
          Not an answering machine. A dispatch brain for your team.
        </h2>

        <div className="mt-12 grid gap-px overflow-hidden rounded-xl border border-white/10 bg-white/10 sm:grid-cols-2 lg:grid-cols-3" data-id="element-57" data-mp="1y78sil5sksj1">
          {dispatchFeatures.map(feature => {
          const Icon = icons[feature.icon];
          return <div key={feature.title} className="bg-ink-800 p-7" data-id="element-58" data-mp="27986f4lifghr">
                <Icon className="h-5 w-5 text-brand" aria-hidden="true" data-id="element-59" data-mp="2c7ji7kvd812m" />
                <h3 className="mt-5 font-display text-lg font-semibold tracking-tight text-white" data-id="element-60" data-mp="2h407iieawlha">
                  {feature.title}
                </h3>
                <p className="mt-2 text-sm leading-relaxed text-white/60" data-id="element-61" data-mp="2m1tcj83vb9fz">{feature.body}</p>
              </div>;
        })}
        </div>
      </div>
    </section>;
}